import {
    MemberPermissionType,
    Task,
    TaskAssigneePermissionType,
    TaskAssigneeStatusType,
    TaskVisibility,
} from '@/types';

const elevatedTaskRoles = new Set([MemberPermissionType.ADMIN, MemberPermissionType.OWNER]);

export function canManageTaskStatuses(memberPermission?: MemberPermissionType) {
    return Boolean(memberPermission && elevatedTaskRoles.has(memberPermission));
}

export function canEditTask(task: Task, memberId?: string, userId?: string, memberPermission?: MemberPermissionType) {
    if (canManageTaskStatuses(memberPermission) || task.user?.id === userId) {
        return true;
    }

    const participant = task.assignees?.find(
        (item) => item.member.id === memberId && item.status === TaskAssigneeStatusType.ACTIVE,
    );

    return (
        participant?.permission === TaskAssigneePermissionType.EDIT ||
        participant?.permission === TaskAssigneePermissionType.OWNER
    );
}

export function canCommentOnTask(
    task: Task,
    memberId?: string,
    userId?: string,
    memberPermission?: MemberPermissionType,
) {
    if (canEditTask(task, memberId, userId, memberPermission)) {
        return true;
    }
    if (task.visibility === TaskVisibility.WORKSPACE) {
        return true;
    }

    return task.assignees?.some(
        (item) =>
            item.member.id === memberId &&
            item.status === TaskAssigneeStatusType.ACTIVE &&
            item.permission === TaskAssigneePermissionType.COMMENT,
    );
}
